import React from "react";
import { FluentProgress } from "../../../../components/FluentUI/Fluent-Progress";
import PropTypes from 'prop-types';

export default function TaskFormProgress({ max, currentSubForm }) {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="progress-text">{`Section ${currentSubForm?.DisplayOrder} of ${max}`}</div>
      <div className="progress-text-bar">
        <FluentProgress
          max={max}
          value={currentSubForm?.DisplayOrder}
        ></FluentProgress>
      </div>
    </div>
  );
}

TaskFormProgress.propTypes = {
  max: PropTypes.number.isRequired,
  currentSubForm: PropTypes.shape({
    DisplayOrder: PropTypes.number.isRequired,
  }).isRequired,
};